import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as html2pdf from 'html2pdf.js';

@Component({
  selector: 'app-score-report',
  templateUrl: './score-report.component.html',
  styleUrls: ['./score-report.component.scss']
})
export class ScoreReportComponent implements OnInit {
  @ViewChild('scoreReporttemplate') public scoreReporttemplate :ElementRef;
  public user_details:any ={}
  public testData:any={};
  public selectedTestData:any;
  isVisbile:boolean = true;
  constructor() { }
  getSecondsinHours =getSecondsinHours;
  getPageHight = getPageHight;
  ngOnInit(): void {
    this.user_details = localStorage.getItem('user_details_from_server') ? JSON.parse(localStorage.getItem('user_details_from_server')):{}
  }

  ngAfterViewInit(){
    setTimeout(() => {
    html2pdf().from(document.getElementById('scoreReport')).set({
      filename: 'Score_Report.pdf',
      image: { type: 'jpeg', quality: 1 },
      margin: 0,
      pagebreak: { mode: 'legacy' },
      jsPDF: { orientation: 'portrait', unit: 'in', size: 'A4' }
    }).save(); 
  }, 1000);
  setTimeout(()=>{
    this.isVisbile = false;
  },2000); 
  }

  

}

export function getSecondsinHours(totalVisitedTime){
  if(totalVisitedTime){

    let testdate: any = new Date(null);
      testdate.setSeconds(totalVisitedTime);
      testdate = testdate.toISOString().substr(11, 8);
      return `${testdate.substring(0,testdate.indexOf(':'),)}h ${testdate.substring(testdate.indexOf(':') + 1,testdate.lastIndexOf(':'),)}m ${testdate.substring(testdate.lastIndexOf(':') + 1, testdate.length)}s`
  }else{
    return 'N/A'
  }
}

export function getPageHight(index){
  return 'pagetwo_show' + index;
}
